import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getFlags,
  setFlags,
  getOngoingThreads,
  getHasSubscriptionToAllVenues,
} from "./api";

const Keys = {
  summaryFlags: ["summaryFlags"],
  ongoingThreads: ["ongoingThreads"],
  hasSubscriptionToAllVenues: ["hasSubscriptionToAllVenues"],
};

export function useGetOngoingThreads(options) {
  return useQuery(Keys.ongoingThreads, getOngoingThreads, options);
}

export function useGetFlags() {
  return useQuery(Keys.summaryFlags, getFlags);
}

export function useSetFlags() {
  return useMutation((flags) => setFlags(flags));
}

export function useHasSubscriptionToAllVenues(options) {
  return useQuery(
    Keys.hasSubscriptionToAllVenues,
    getHasSubscriptionToAllVenues,
    options
  );
}
